/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 05-11-2026 12:02:02

export enum DoorstroomResultaatMetPrognose {
    DOORSTROOM = "Doorstroom",
    DOORSTROOM_PROGNOSE = "Doorstroom (prognose)",
    GESLAAGD = "Geslaagd",
    GESLAAGD_PROGNOSE = "Geslaagd (prognose)",
    OPSTROOM = "Opstroom",
    OPSTROOM_PROGNOSE = "Opstroom (prognose)",
    AFSTROOM = "Afstroom",
    AFSTROOM_PROGNOSE = "Afstroom (prognose)",
    DOUBLURE = "Doublure",
    DOUBLURE_PROGNOSE = "Doublure (prognose)",
    AFGEWEZEN = "Afgewezen",
    AFGEWEZEN_PROGNOSE = "Afgewezen (prognose)",
    VO_VERLATER = "VO verlater",
    GEEN = "Geen"
}
